//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AlertCreated } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

// haleakala
import AlertEditor from "components/AlertEditor/AlertEditor.jsx";

//icons
//import Close from "@material-ui/icons/Close";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class Alerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: []
    }
  }

    getFormattedDateTime(value) {

        function addZero(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        }
        
        value = new Date(value * 1000);
        return (value.getUTCMonth()+1) + '/' + value.getUTCDate() + '/' + value.getUTCFullYear() + ' ' + addZero(value.getUTCHours()) + '.' + addZero(value.getUTCMinutes());
    }

  componentDidMount() {

    if (this.props.user.authenticated) {
      
      db.getAlerts(this.props.org.id).then(snapshot => {

        var alerts = [];
        snapshot.forEach((doc) => {
          
          var alert = doc.data();
          alert.id = doc.id;
          alert.DateTimeSent = this.getFormattedDateTime(alert.dateTimeSent);

          alerts.splice(0, 0, alert);
        });

        
        
        //this.props.onProductsLoaded(products);
        this.setState({alerts:alerts});
      });
    }
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Alerts</h4>
                  <p className={classes.cardCategoryWhite}>
                    Send alerts directly to your visitors mobile phones.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}} >
                  <Tooltip
                        id="tooltip-top-start"
                        title="New Alert"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                      >
                      <AlertEditor  />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <Table className={classes.table}>
                <TableBody>
                  {this.state.alerts.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableCell}>
                        {value.DateTimeSent}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Audience}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Message}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onAlertCreated: AlertCreated }, dispatch);  
}

Alerts = connect(mapStateToProps, mapDispatchToProps)(Alerts);
export default withStyles(styles)(Alerts);



// WEBPACK FOOTER //
// ./src/views/Alerts/Alerts.jsx